import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { ApiService } from './api.service';

@Injectable()
export class FaoZoneService extends ApiService {
  constructor(private http: Http) {
    super('api/fao-zones/', http);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/fao-zone.service.ts